import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();

  // Inject Clarity and Google Analytics script for production

  const clarityScript = document.createElement('script');
  clarityScript.type = 'text/javascript';
  clarityScript.innerHTML = `
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "ly0gu4r985");
  `;
  document.head.appendChild(clarityScript);

  // Inject Google Tag Manager noscript in the head
  const gtmScript = document.createElement('script');
  gtmScript.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-WMLLSGJL');
  `;
  document.head.appendChild(gtmScript);

  // Inject Google Tag Manager noscript in the body
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WMLLSGJL"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;
  document.body.appendChild(noscript);

}

async function bootstrapApp(): Promise<void> {
  // Ensure JIT compiler is present in dev-like modes when NgModule bootstrap is used.
  if (!environment.production) {
    await import('@angular/compiler');
  }

  await platformBrowserDynamic().bootstrapModule(AppModule);
}

bootstrapApp().catch((err) => {
  if (!environment.production) {
    console.error(err);
  }
});
